import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';

export default function Dashboard() {
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    api('/marketing/campaigns').then(r => r.json()).then(setCampaigns).catch(() => {});
  }, []);

  const active = campaigns.filter(c => c.status === 'active').length;
  const totalBudget = campaigns.reduce((sum, c) => sum + (c.budget || 0), 0);

  return (
    <Layout>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm text-gray-500">Total Campaigns</p>
          <p className="text-2xl font-bold text-gray-900">{campaigns.length}</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm text-gray-500">Active</p>
          <p className="text-2xl font-bold text-green-600">{active}</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm text-gray-500">Total Budget</p>
          <p className="text-2xl font-bold text-gray-900">${totalBudget.toLocaleString()}</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm text-gray-500">Platforms</p>
          <p className="text-2xl font-bold text-gray-900">{new Set(campaigns.map(c => c.platform)).size}</p>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-6 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-900">Recent Campaigns</h2>
          <a href="/marketing/campaigns/new" className="bg-fuchsia-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-fuchsia-700">New Campaign</a>
        </div>
        <div className="divide-y divide-gray-200">
          {campaigns.slice(0, 5).map(c => (
            <a key={c.id} href={`/marketing/campaigns/${c.id}`} className="flex items-center justify-between p-4 hover:bg-gray-50">
              <div>
                <p className="font-medium text-gray-900">{c.name}</p>
                <p className="text-sm text-gray-500">{c.platform}</p>
              </div>
              <span className={`px-2 py-1 rounded text-xs font-medium ${c.status === 'active' ? 'bg-green-100 text-green-800' : c.status === 'paused' ? 'bg-yellow-100 text-yellow-800' : c.status === 'completed' ? 'bg-gray-100 text-gray-800' : 'bg-blue-100 text-blue-800'}`}>
                {c.status}
              </span>
            </a>
          ))}
          {campaigns.length === 0 && <p className="p-4 text-gray-500 text-center">No campaigns yet.</p>}
        </div>
      </div>
    </Layout>
  );
}
